import { useApi } from '@/api';
import { ChartSkeleton, ChartTimeFilter } from '@/components';
import { Flex, DisplaySwitch } from '@blockanalitica/ui';
import { useMemo, useState } from 'react';
import HistoricGraphs from './HistoricGraphs';

export default function LitePSMHistoricTabs({ ilk }) {
  const [activeDisplayOption, setActiveDisplayOption] = useState('reserve');
  const [chartDaysAgo, setChartDaysAgo] = useState('30');
  const displayOptions = useMemo(
    () => [
      { key: 'reserve', value: 'USDC' },
      { key: 'dai', value: 'DAI' },
      { key: 'debt', value: 'Total Debt' }
    ],
    []
  );

  let url = `/groups/stablecoins/ilks/${ilk}/historic/`;
  if (activeDisplayOption == 'reserve' || activeDisplayOption == 'dai') {
    url = `/groups/stablecoins/ilks/${ilk}/snapshots/`;
  }
  const [data, error] = useApi({
    url: url,
    queryParams: {
      days_ago: chartDaysAgo
    }
  });

  if (error) {
    throw error;
  }
  const timeFilter = useMemo(
    () => (
      <ChartTimeFilter activeOption={chartDaysAgo} onChange={setChartDaysAgo} />
    ),
    [chartDaysAgo]
  );

  if (data) {
    return (
      <Flex flexDirection="column" gap="xs">
        <DisplaySwitch
          data={displayOptions}
          activeOption={activeDisplayOption}
          onChange={setActiveDisplayOption}
        />
        <HistoricGraphs
          data={data}
          type={activeDisplayOption}
          timeFilter={timeFilter}
          chartDaysAgo={chartDaysAgo}
        />
      </Flex>
    );
  }

  return <ChartSkeleton />;
}
